'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateAddressForm = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _AddressesForm2 = require('./AddressesForm');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateAddressForm = exports.CreateAddressForm = function (_AddressesForm) {
  (0, _inherits3.default)(CreateAddressForm, _AddressesForm);

  function CreateAddressForm(container) {
    (0, _classCallCheck3.default)(this, CreateAddressForm);
    return (0, _possibleConstructorReturn3.default)(this, (CreateAddressForm.__proto__ || Object.getPrototypeOf(CreateAddressForm)).call(this, container));
  }

  return CreateAddressForm;
}(_AddressesForm2.AddressesForm);